<div dir="ltr" style="height: 100%;">
  
  <router-outlet></router-outlet>
</div>
